/**
 * =============================================================
 * AADHAV ACADEMY – ADMIN INVESTMENTS API
 * Role: Admin
 * Scope: Tenant-based Investment Management with Branch Mapping
 * Standard: Enterprise / MNC Level
 * =============================================================
 */

import { apiCall } from "../core/apiCall";

const ADMIN_INVESTMENTS_ENDPOINT = "/admin/Investors/investments.php";

export const getAdminInvestments = async (
  { page = 1, limit = 10, search = "", status = "", branch_id = "" } = {},
  options = {}
) => {
  try {
    const res = await apiCall(
      "GET",
      ADMIN_INVESTMENTS_ENDPOINT,
      null,
      "Admin – Fetch Investments",
      {
        params: { page, limit, search, status, branch_id },
        ...options,
      }
    );

    if (!res || res.status !== true) {
      return {
        success: false,
        message: res?.message || "Failed to fetch investments",
        data: [],
        meta: {},
      };
    }

    return {
      success: true,
      data: res.data || [],
      meta: res.meta || {
        total: 0,
        page: 1,
        limit,
        total_pages: 0,
      },
    };
  } catch (error) {
    console.error("Admin Fetch Investments Error:", error);
    return {
      success: false,
      message: error.message || "Unexpected error occurred",
      data: [],
      meta: {},
    };
  }
};

export const getAdminInvestmentById = async (id, options = {}) => {
  try {
    if (!id) {
      return { success: false, message: "Invalid investment ID" };
    }

    const res = await apiCall(
      "GET",
      `${ADMIN_INVESTMENTS_ENDPOINT}?id=${id}`,
      null,
      "Admin – Fetch Investment By ID",
      options
    );

    if (!res || res.status !== true) {
      return { success: false, message: res?.message || "Failed to fetch investment" };
    }

    return { success: true, data: res.data };
  } catch (error) {
    console.error("Admin Fetch Investment By ID Error:", error);
    return { success: false, message: error.message || "Unexpected error occurred" };
  }
};

export const createAdminInvestment = async (payload, options = {}) => {
  try {
    const res = await apiCall(
      "POST",
      ADMIN_INVESTMENTS_ENDPOINT,
      payload,
      "Admin – Create Investment",
      options
    );

    if (!res || res.status !== true) {
      return { success: false, message: res?.message || "Failed to create investment" };
    }

    return { success: true, data: res.data, message: res.message };
  } catch (error) {
    console.error("Admin Create Investment Error:", error);
    return { success: false, message: error.message || "Unexpected error occurred" };
  }
};

export const updateAdminInvestment = async (id, payload, options = {}) => {
  try {
    if (!id) {
      return { success: false, message: "Invalid investment ID" };
    }

    const res = await apiCall(
      "PUT",
      `${ADMIN_INVESTMENTS_ENDPOINT}?id=${id}`,
      payload,
      "Admin – Update Investment",
      options
    );

    if (!res || res.status !== true) {
      return { success: false, message: res?.message || "Failed to update investment" };
    }

    return { success: true, data: res.data || null, message: res.message || "Investment updated successfully" };
  } catch (error) {
    console.error("Admin Update Investment Error:", error);
    return { success: false, message: error?.message || "Unexpected error occurred" };
  }
};

export const deleteAdminInvestment = async (id, options = {}) => {
  try {
    if (!id) {
      return { success: false, message: "Invalid investment ID" };
    }

    const res = await apiCall(
      "DELETE",
      `${ADMIN_INVESTMENTS_ENDPOINT}?id=${id}`,
      null,
      "Admin – Delete Investment",
      options
    );

    if (!res || res.status !== true) {
      return { success: false, message: res?.message || "Failed to delete investment" };
    }

    return { success: true, message: res.message };
  } catch (error) {
    console.error("Admin Delete Investment Error:", error);
    return { success: false, message: error.message || "Unexpected error occurred" };
  }
};